module.exports = __webpack_public_path__ + "img/tng.f34d2199.png";